import { useEffect, useRef } from 'react'

/** Route the platform print shortcut through the same action as the print button. */
export function usePrintShortcut(action: () => void, enabled = true) {
  const latest = useRef(action)
  latest.current = action
  useEffect(() => {
    if (!enabled) return
    const onKey = (event: KeyboardEvent) => {
      if (
        event.key.toLowerCase() !== 'p' ||
        !(event.ctrlKey || event.metaKey) ||
        event.altKey
      )
        return
      event.preventDefault()
      latest.current()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [enabled])
}
